export function getDateTime(dateTime: Date) {
    return new Date(dateTime).toLocaleString(navigator.language);
} 

export function getTime(dateTime: Date, dateFormat: string) {
    if (dateFormat === "DateTime") {
        return new Date(dateTime).toLocaleString(navigator.language);
    } else if (dateFormat === "Date") {
        return new Date(dateTime).toLocaleDateString(navigator.language);
    } else if (dateFormat === "Time") {
        return new Date(dateTime).toLocaleTimeString(navigator.language);
    } else {
        return new Date(dateTime).toLocaleTimeString(navigator.language).replace(/(.*)\D\d+/, '$1');
    }
}